export enum ChatTools {
  auto = 'auto',
  hypothesis = 'hypothesis',
  vision = 'vision',
  impact = 'impact',
  persona = 'persona',
  expert = 'expert',
  interview = 'interview',
  scenario = 'scenario',
  trends = 'trends',
  motivations = 'motivations',
  brief = 'brief',
  subthemes = 'subthemes',
  holistic = 'holistic',
  future = 'future',
}

export enum LLMModel {
  Claude_Sonnet_4_0 = 'Sonnet 4',
  GPT_5 = 'GPT-5',
  Gemini_2_5 = 'Gemini 2.5',
  // GPT_OpenAI_o3 = 'openAI 03',
}

export enum PromptKey {
  ARTIFACT_CLASSIFIER = 'artifact_classifier', // 아티팩트 분류 및 제목 생성
  IMAGE_TO_IMAGE_CONVERTER = 'image_to_image_converter', // 참조 이미지 기반 이미지 생성 프롬프트
  AI_CHAT_IMAGE_EDITOR = 'ai_chat_image_editor', // AI 채팅 이미지 편집
  IMAGE_INPAINTING_EDITOR = 'image_inpainting_editor', // 이미지 인페인팅 편집
  THREE_D_TO_IMAGE_CONVERTER = '3d_to_image_converter', // 3D 모델을 2D 이미지로 변환
  THREE_D_TO_PROMPT_CONVERTER = '3d_to_prompt_converter', // 3D 모델을 텍스트 설명으로 변환
  IMAGE_TO_PROMPT_CONVERTER = 'image_to_prompt_converter', // 이미지를 텍스트 프롬프트로 변환
  PROMPT_ENHANCER_TEXT = 'prompt_enhancer_text', // 텍스트 프롬프트 개선
  IMAGE_CLASSIFIER = 'image_classifier', // 이미지 생성 요청 분류
  TOOL_SELECTOR = 'tool_selector', // 적절한 도구 선택
  GENERAL_MAESTRO_PROMPT = 'general_maestro_prompt', // 메인 대화 프롬프트

  PALETTE_TO_PROMPT_CONVERTER = 'palette_to_prompt',
  PALETTE_TO_IMAGE_CONVERTER = 'palette_to_image',
}

// 프롬프트별 변수 타입
export type PromptVariables = {
  [PromptKey.PALETTE_TO_PROMPT_CONVERTER]: {
    PALETTE_TYPE: string; //"options": ["Material", "Color", "Style", "Model", "CameraView", "Etc"],
    USER_QUERY: string; // 사용자 입력 쿼리
  };
  [PromptKey.PALETTE_TO_IMAGE_CONVERTER]: {
    PALETTE_TYPE: string; //"options": ["Material", "Color", "Style", "Model", "CameraView", "Etc"],
    USER_QUERY: string; // 사용자 입력 쿼리
  };
  [PromptKey.ARTIFACT_CLASSIFIER]: {
    ARTIFACT_CONTENT: string; // 분류할 아티팩트 내용
  };

  [PromptKey.IMAGE_TO_IMAGE_CONVERTER]: {
    PROMPT_STYLE: string; // 프롬프트 스타일
    TARGET_PURPOSE: string; // 활용 목적
    CONNECTED_ARTIFACTS_CONTENT: string; // 아티팩트 컨텍스트
    FIELDS_CONTENT: string; // 사용자 추가 요청
  };

  [PromptKey.AI_CHAT_IMAGE_EDITOR]: {
    USER_QUERY: string; // 사용자 입력 쿼리
  };

  [PromptKey.IMAGE_INPAINTING_EDITOR]: {
    USER_QUERY: string; // 사용자 입력 쿼리
  };

  [PromptKey.THREE_D_TO_IMAGE_CONVERTER]: {
    PROMPT_STYLE: string; // 프롬프트 스타일
    TARGET_PURPOSE: string; // 활용 목적
    CONNECTED_ARTIFACTS_CONTENT: string; // 아티팩트 컨텍스트
    FIELDS_CONTENT: string; // 사용자 추가 입력
  };

  [PromptKey.THREE_D_TO_PROMPT_CONVERTER]: {
    PROMPT_STYLE: string; // 프롬프트 스타일
    TARGET_PURPOSE: string; // 활용 목적
    CONNECTED_ARTIFACTS_CONTENT: string; // 아티팩트 컨텍스트
    FIELDS_CONTENT: string; // 사용자 추가 컨텍스트
  };

  [PromptKey.IMAGE_TO_PROMPT_CONVERTER]: {
    PROMPT_STYLE: string; // 프롬프트 스타일
    TARGET_PURPOSE: string; // 활용 목적
    CONNECTED_ARTIFACTS_CONTENT: string; // 아티팩트 컨텍스트
    FIELDS_CONTENT: string; // 사용자 추가 지침
  };

  [PromptKey.PROMPT_ENHANCER_TEXT]: {
    TARGET_AI: string; // 타겟 AI 모델명
    CONNECTED_ARTIFACTS_CONTENT: string; // 아티팩트 컨텍스트
    FIELDS_CONTENT: string; // 사용자 입력 필드
  };

  [PromptKey.IMAGE_CLASSIFIER]: {
    USER_QUERY: string; // 사용자 입력 쿼리
  };

  [PromptKey.TOOL_SELECTOR]: {
    USER_QUERY: string; // 사용자 입력 쿼리
  };

  [PromptKey.GENERAL_MAESTRO_PROMPT]: {
    USER_QUERY: string; // 사용자 입력 쿼리
  };
};
